module.exports = __webpack_public_path__ + "static/media/test10_4.1c0e4595.png";